import React from 'react'

import { Typography, Container, Grid } from '@mui/material'

import { formatNumber } from '@edge/spark/utils'
import { LinearProgressBar, TypographyLoader } from '@edge/spark/ui'

import { WidgetContainer } from '../../../WidgetContainer'
import { CardType } from '@edge/spark/io-dashboards'

interface Props {
    cardType: CardType
    action: {
        text: string
        link: string
    }
    checkIn?: number | null
    run?: number | null
    sold?: number | null
    conversion: number
    loading: boolean
    cardHeaderText: string
    secondaryText?: string
    widgetId: string
    handleConfig?: (widgetId: string) => void
    readonly: boolean
}

const SalesRange: React.FC<Props> = ({
    action,
    run,
    sold,
    checkIn,
    loading,
    conversion,
    cardHeaderText,
    widgetId,
    handleConfig,
    readonly,
}: Props) => {
    return (
        <WidgetContainer
            readonly={readonly}
            loading={loading}
            cardType={CardType.CUSTOM}
            cardHeaderText={cardHeaderText}
            action={action}
            widgetId={widgetId}
            handleConfig={handleConfig}
        >
            <Container sx={{ mt: 1, display: 'flex', textAlign: 'center', width: '100%' }}>
                <Grid container item xs direction="column">
                    <Grid item data-test="CheckIn">
                        <TypographyLoader
                            loaderWidth={80}
                            variant="h5"
                            loading={loading && typeof checkIn !== 'number'}
                        >
                            <span>{checkIn && checkIn >= 0 ? formatNumber(checkIn) : 0}</span>
                        </TypographyLoader>
                    </Grid>
                    <Typography variant="subtitle2">Registered</Typography>
                </Grid>
                <Grid container item xs direction="column">
                    <Grid item data-test="Ran">
                        <TypographyLoader loaderWidth={80} variant="h5" loading={loading && typeof run !== 'number'}>
                            {run && run >= 0 ? formatNumber(run) : 0}
                        </TypographyLoader>
                    </Grid>
                    <Typography variant="subtitle2">Ran</Typography>
                </Grid>
                <Grid container item xs direction="column">
                    <Grid item data-test="Sold">
                        <TypographyLoader loaderWidth={80} variant="h5" loading={loading && typeof sold !== 'number'}>
                            {sold && sold >= 0 ? formatNumber(sold) : 0}
                        </TypographyLoader>
                    </Grid>
                    <Typography variant="subtitle2">Sold</Typography>
                    <Typography variant="caption">*excludes IFs/Arbs</Typography>
                </Grid>
            </Container>
            <LinearProgressBar text="Conversion" value={conversion} />
        </WidgetContainer>
    )
}

export default SalesRange
